import React, { useState } from 'react';

// 3 критерия для балла (все должны быть "Да" для 1 балла) — балл считает
// СЕРВЕР из этих ответов, компонент сам ничего не вычисляет и не
// отправляет готовое число (см. manual_scores.py: неизвестное поле вроде
// "points" сервер теперь явно отклоняет, а не молча принимает).
const PENTAGON_CRITERIA = [
  { key: "fiveSides", label: "Ровно 5 сторон у каждого пятиугольника?" },
  { key: "intersection", label: "Фигуры пересекаются (есть наложение)?" },
  { key: "quadrilateral", label: "Зона перекрытия — четырёхугольник?" }
];

// 2 красных флага (не влияют на балл, только для врача)
const RED_FLAGS = [
  { key: "neglect", label: "Неглект (левая сторона недорисована)?" },
  { key: "perseveration", label: "Персеверация (рисует лишнее)?" }
];

export default function DrawingChecklistPentagon({ itemId, onSubmit }) {
  const [answers, setAnswers] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const handleToggle = (key, val) => {
    setAnswers({ ...answers, [key]: val });
  };

  const handleSubmit = async () => {
    const allAnswered = PENTAGON_CRITERIA.every(c => answers[c.key] !== undefined);
    if (!allAnswered) {
      alert("Ответьте на 3 ключевых вопроса.");
      return;
    }

    // ИСПРАВЛЕНО: раньше здесь считался и отправлялся готовый балл
    // (points) — то есть компонент сам решал, правильный ли ответ.
    // Теперь отправляются ТОЛЬКО ответы чек-листа (включая красные
    // флаги как необязательную качественную заметку) — сервер сам
    // переводит да/нет в балл, как и для куба/часов.
    setSubmitting(true);
    try {
      await onSubmit(itemId, { ...answers });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col gap-3 text-left p-3 bg-secondary/20 rounded-lg border border-border w-full max-w-md">
      <p className="text-sm font-bold text-primary mb-1">Оценка пятиугольников</p>
      
      {PENTAGON_CRITERIA.map((c) => (
        <div key={c.key} className="flex items-center justify-between gap-2">
          <span className="text-xs text-primary font-medium">{c.label}</span>
          <div className="flex gap-1">
            <button onClick={() => handleToggle(c.key, true)} className={`px-2 py-0.5 text-xs rounded border ${answers[c.key] === true ? 'bg-green-500 text-white border-green-500' : 'bg-background text-muted-foreground border-border'}`}>Да</button>
            <button onClick={() => handleToggle(c.key, false)} className={`px-2 py-0.5 text-xs rounded border ${answers[c.key] === false ? 'bg-red-500 text-white border-red-500' : 'bg-background text-muted-foreground border-border'}`}>Нет</button>
          </div>
        </div>
      ))}

      <div className="mt-2 pt-2 border-t border-border">
        <p className="text-xs text-muted-foreground italic mb-2">Красные флаги (не влияют на балл):</p>
        {RED_FLAGS.map((c) => (
          <div key={c.key} className="flex items-center justify-between gap-2">
            <span className="text-xs text-muted-foreground">{c.label}</span>
            <div className="flex gap-1">
              <button onClick={() => handleToggle(c.key, true)} className={`px-2 py-0.5 text-xs rounded border ${answers[c.key] === true ? 'bg-yellow-500 text-white border-yellow-500' : 'bg-background text-muted-foreground border-border'}`}>Да</button>
              <button onClick={() => handleToggle(c.key, false)} className={`px-2 py-0.5 text-xs rounded border ${answers[c.key] === false ? 'bg-background text-primary border-primary' : 'bg-background text-muted-foreground border-border'}`}>Нет</button>
            </div>
          </div>
        ))}
      </div>

      <button onClick={handleSubmit} disabled={submitting} className="mt-2 bg-primary text-white text-xs py-2 rounded hover:bg-primary/90 disabled:opacity-40">
        {submitting ? 'Сохранение...' : 'Сохранить оценку'}
      </button>
    </div>
  );
}